import { CountryCode } from '../../i18n/countryCodes'
import { IDefaultServices } from './loadDefaultTaxServices'

export default function updateDefaultTaxServices(api: GlobalFetch) {
  return async function(
    lang: CountryCode,
    services: IDefaultServices[],
    defaultService,
  ) {
    const requestBody = { lang, ...defaultService, ...services }

    const buildUrl = `/api/v2/service/default`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return responseBody.items[0]
  }
}

export interface IData {
  messages: string[]
  items: IDefaultServices[]
}
